





import Vue from 'vue';

// export type DataType = {
// };

export default Vue.extend({
  name: 'admin-home',
  // data(): DataType {
  //   return {
  //   };
  // },
  // methods: {
  // },
});
